import ModelService from "../services/ModelService";
import TableUtil from "./TableUtil";

export default class ViewUtil {

    constructor(table, view) {
        this.table = table
        this.view = view
    }

    setLinkedObjectFilterData(document, openFormModalFunction) {
        for (let i = 0; i < this.view.filters.length; i++) {
            let filter = this.view.filters[i]
            let field = this.getField(filter)

            if (field.field_type === 'Link to Object') {

                let tableId = field.related_model_id
                let relatedTable = webase.managers.app.getTable(tableId)
                let documentId = filter.filter_value
                let service = new ModelService()

                service.getDocument(relatedTable, documentId).then((response) => {

                    let tableUtil = new TableUtil()
                    let primaryField = tableUtil.getPrimaryField(relatedTable)
                    let fieldValue = response[primaryField.index]
                    let updatedValue = {}
                    updatedValue[documentId] = fieldValue
                    document[field.index] = updatedValue

                    openFormModalFunction()

                }).catch((message) => {
                    console.log('error loading table')
                    console.log(message)
                })
            }
        }
    }

    getLinkedObjectFilter() {
        if (!this.view.filters || this.view.filters.length === 0) {
            return null
        }

        for (let i = 0; i < this.view.filters.length; i++) {
            let filter = this.view.filters[i]
            let field = this.getField(filter)

            if (field.field_type === 'Link to Object') {
                return filter
            }
        }

        return null
    }

    hasLinkedObjectFilter() {
        return this.getLinkedObjectFilter() !== null
    }

    getField(filter) {
        return this.table.fields.reduce((previousValue, currentValue) => {
            return currentValue.id === filter.field_id ? currentValue : previousValue;
        }, this.table.fields[0])
    }
}